export default "__VITE_ASSET__C5X7gtGD__"